/*!
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {DatePicker} from '@pearson-components/elements-sdk/build/dist.elements-sdk';

export  class OfferDetailsDatePicker extends Component {
    constructor(props) {
        super(props);
    }
    static get propTypes() {
        return {
            options: PropTypes.object.isRequired,
            offerDetails: PropTypes.array.isRequired,
            DateDisabled: PropTypes.bool
        };
    }

    render() {
        return (<DatePicker id="offerEndDate"
            dateFormat='yyyy-mm-dd'
            labelText="End Date (yyyy-mm-dd)"
            disablePast={true}
            datePickerValue={Moment.utc(this.props.options.offers.offerEndDate).format('YYYY-MM-DD')}
            changeHandler={(changeDate) => this.props.options.offerEndDateChangeHandler(changeDate, this.props.options.offers.offerId, this.props.options.index)} 
            inputState={this.props.DateDisabled ? 'disabled' : ''}/>);
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OfferDetailsDatePicker.js